export enum E_CommsMethod {
  SMS = "sms",
  EMAIL = "email",
  LETTER = "letter",
}
